import React from 'react'

function CardsList({ cards, limit }) {
  return (
    <>
      {cards
        ? cards.slice(0, limit).map((card) => (
          <article className="filter-content__article " key={card.Id}>
            <img
              className="filter-content__article-img"
              src={card.Image}
              width="277"
              height="207"
              alt={card.Heading}
              loading="lazy"
            />

            <div className="filter-content__article-content">
              <h3 className="filter-content__article-heading">
                <a href={card.Url} className="filter-content__article-link">
                  {card.Heading}
                </a>
              </h3>
              <p className="filter-content__article-copy">{card.Summary}</p>
            </div>
          </article>
        ))
        : null}
    </>
  )
}

export default CardsList
